module.exports = __webpack_public_path__ + "static/img/syd.2d24bd2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/syd.jpg
// module id = TwXJ
// module chunks = 1